import i18next from 'i18next';
import { nth, createdAt } from '../../../common/utils';

// https://github.com/react-tools/react-table#columns
export const getColumns = (lang) => {
  return [
    nth,
    {
      Header: () => i18next.t('my:pos.tableHeaders.company'),
      accessor: 'company_name',
      maxWidth: 160
    },
    {
      Header: i18next.t('my:pos.tableHeaders.family_name'),
      accessor: 'family_name',
      maxWidth: 120
    },
    {
      Header: i18next.t('my:pos.tableHeaders.given_name'),
      accessor: 'given_name',
      maxWidth: 120
    },
    {
      Header: i18next.t('my:pos.tableHeaders.teamCount'),
      id: 'teamCount',
      Cell: (row) => row.original.teams.length || 0,
      maxWidth: 80
    },
    {
      Header: i18next.t('my:pos.tableHeaders.email'),
      accessor: 'email',
      maxWidth: 200
    },
    createdAt
  ];
};

export const getNoDataText = () => {
  return i18next.t('my:pos.no_data');
};

export const DEFAULTSORTED = [
  { id: 'company', desc: false },
  { id: 'family_name', desc: false },
  { id: 'given_name', desc: false }
];

export const DEFAULTPAGESIZE = 20;



// WEBPACK FOOTER //
// ./src/private/user/components/PurchaseOrders/table.conf.js